var map = {
	"./arb.svg": 1158,
	"./bch.svg": 1159,
	"./btc.svg": 1160,
	"./dash.svg": 1161,
	"./eth.svg": 1162,
	"./ltc.svg": 1163,
	"./mxn.svg": 292,
	"./mxnb.svg": 1164,
	"./sol.svg": 1165,
	"./tdc.svg": 1166,
	"./tether.svg": 1167,
	"./trx.svg": 1168,
	"./usd.svg": 117,
	"./usdt.svg": 1169,
	"./vmxn.svg": 206,
	"./xrp.svg": 1170
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19;